import React from "react"
import Row from "@amzn/meridian/row"
import Button from "@amzn/meridian/button"
import ModalExample from "@amzn/meridian/modal";
import ModalFooter from "@amzn/meridian/modal/modal-footer";
import Alert from "@amzn/meridian/alert";

/**
 * This component will render Alert model with required message
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AlertModal = (props) => {
    const onClose = event => {
        props.onClose(event);
    }

    return (
        <React.Fragment>
            <ModalExample title={props.title} open={props.show} scrollContainer="viewport"
                          closeLabel="Close" onClose={onClose}>

                <Alert type={props.type ? props.type : "informational"}>{props.message}</Alert>
                <ModalFooter>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onClose}>
                            Ok
                        </Button>
                    </Row>
                </ModalFooter>
            </ModalExample>
        </React.Fragment>
    );
}

export default AlertModal;


// WEBPACK FOOTER //
// ./src/component/modal/alertModal.js